// @flow
import React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import Layout from '../components/layout';
import PageMeta from '../components/PageMeta';

import chrisProfile from '../assets/images/chris-profile.jpg';

export default () => (
  <Layout>
    <PageMeta title="About Us | CS Frequency" />
    <section className="module-page-title">
      <div className="container">
        <div className="row-page-title">
          <div className="page-title-captions">
            <h1 className="h3">About Us</h1>
          </div>
          <div className="page-title-secondary">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <GatsbyLink to="/">Home</GatsbyLink>
              </li>
              <li className="breadcrumb-item active">About Us</li>
            </ol>
          </div>
        </div>
      </div>
    </section>
    <section className="module module-divider-bottom">
      <div className="container">
        <div className="row m-b-100">
          <div className="col-md-12">
            <div className="special-heading">
              <h3>Who are we</h3>
            </div>
            <p>
              CS Frequency is a UK based consultancy focused on delivering high
              quality web, mobile and cloud solutions to clients worldwide. We
              pride ourselves on working closely with our clients to meet their
              requirements by utilising the technology that is appropriate for
              their needs.
            </p>
            {/*
            <blockquote>
              <p>A quote</p>
              <city>- Quote by ...</city>
            </blockquote>
            */}
          </div>
        </div>
        <div className="row m-b-100">
          <div className="col-md-12">
            <div className="special-heading">
              <h3>Founder: Chris Bianca</h3>
            </div>
          </div>
          <div className="col-md-3">
            <div className="team-item m-b-30">
              <div>
                <img src={chrisProfile} alt="" />
              </div>
            </div>
          </div>
          <div className="col-md-9">
            <p>
              Chris spent over 7 years at Ocado, where he was responsible for
              all development and architecture for their web and mobile
              platform, growing it to support over £1 billion in annual
              transactions. As part of Ocado's first partnership agreement in
              2013, he ran development for and launched the Morrisons Grocery
              website. Chris doesn't just focus on technology, he was heavily
              involved in product development as well as managing the business
              relationship with Ocado's retail team and their counterparts at
              Morrisons. Before leaving in 2015, Chris designed and architected
              the migration of Ocado's Web and Mobile platform to the cloud
              using a combination of AWS and Google Cloud Platform. This now
              forms the basis of Ocado's Smart Platform offering.
            </p>
            <p>
              Since leaving, Chris has worked with startups and established
              organisations like Anthony Nolan to help set out their cloud
              strategy and migration paths. He remains hands-on and has
              contributed heavily to the open source community on projects like
              React Native Firebase to ensure that he keeps abreast of new
              technologies.
            </p>
            <div className="team-social">
              <ul>
                <li>
                  <a href="https://www.linkedin.com/in/chrisbianca">
                    <i className="fab fa-linkedin" />
                  </a>
                </li>
                <li>
                  <a href="https://twitter.com/chrisjbianca">
                    <i className="fab fa-twitter" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  </Layout>
);
